import * as wecom from '@wecom/jssdk';

const isPosPath = location.pathname.toLowerCase().startsWith(`/pos`) || location.search.includes('return=/POS/');

if (!IS_PROD) {
  if (isPosPath) {
    if (/Mac OS X/.test(navigator.userAgent)) {
      window.__POS_Device__ = {
        playSound: () => false,
        setConsumerDisplayImage: () => void 0,
        setConsumerWecomQrImage: () => void 0,
        getUUID: () => `mock-${new Date().getTime().toString(36)}`,
        getTbsVersion: () => 0,
        getX5Loaded: () => false,
        canLoadX5: () => false,
        initX5: () => {},
        debugX5: () => {},
        openAppSettings: () => {},
        getVersion: () => 'N/A',
        getVersionCode: () => 0,
        checkUpdate: () => {},
        getConnectedUsbDevices: () => '',
        connectUsb: () => '',
        isScreenOff: () => undefined,
      } as Window['__POS_Device__'];
    }
  }
}

export const IS_REAL_POS = !!window.__POS_Device__ && !window.__POS_Device__.getUUID().startsWith(`mock-`);
export const IS_POS = !!window.__POS_Device__;
export const IS_WECOM = wecom.env.isWeCom;
